<ng-container *transloco="let t; read: 'inventory.detail'">
  <ng-container *transloco="let tGlobal; read: 'global'">
    @if (vm$ | async; as vm) {
      <div class="componentContainer">
        <section class="xs12col componentHeader">
          <h1>{{ isNew ? t('titleNew') : (vm.device?.name || t('title')) }}</h1>
        </section>
        <kendo-tabstrip>
          <kendo-tabstrip-tab title="{{ t('tab.general') }}" [selected]="true">
            <ng-template kendoTabContent>
              <section class="oneCol">
                <div class="xs12col">
                  <form [formGroup]="deviceForm" class="flexColumn">
                    <div class="fieldsetWrapper flexRow">
                      <div class="xs12col m4col align-top">
                        <fieldset class="fieldsetContainer">
                          <h2 class="padding-bottom-small">{{ t('general') }}</h2>
                          @if (isAdminView) {
                            <kendo-formfield>
                              <kendo-label [text]="t('company')">*</kendo-label>
                              <kendo-dropdownlist
                                [data]="vm.companies"
                                textField="name"
                                valueField="id"
                                [defaultItem]="{ id: null, name: t('chooseCustomer') }"
                                formControlName="companyId"
                                [readonly]="!isNew"
                                [valuePrimitive]="true">
                              </kendo-dropdownlist>
                            </kendo-formfield>
                          }
                          <!-- plain wrapper: kendo-formfield requires exactly one form control and throws in dev mode otherwise -->
                          <div class="k-form-field">
                            <kendo-label [text]="isActive ? t('activeYes') : t('activeNo')"></kendo-label>
                            @if (canEdit) {
                              <a class="toggleActiveLink" role="button" tabindex="0"
                                (click)="toggleActive()"
                                (keydown.enter)="toggleActive()">
                                {{ isActive ? t('deactivate') : t('activate') }}
                              </a>
                            }
                          </div>
                          <kendo-formfield>
                            <kendo-label [text]="t('location')"></kendo-label>
                            <kendo-textbox formControlName="location"></kendo-textbox>
                          </kendo-formfield>
                          <kendo-formfield>
                            <kendo-label [text]="t('remarks')"></kendo-label>
                            <kendo-textarea
                              [rows]="4"
                              formControlName="remarks">
                            </kendo-textarea>
                          </kendo-formfield>
                        </fieldset>
                      </div>
                      <div class="xs12col m4col align-top">
                        <fieldset class="fieldsetContainer">
                          <h2 class="padding-bottom-small">{{ t('device') }}</h2>
                          <kendo-formfield>
                            <kendo-label [text]="t('serialNumber')">*</kendo-label>
                            <kendo-textbox formControlName="serialNumber"></kendo-textbox>
                            @if (deviceForm.get('serialNumber')?.touched && deviceForm.get('serialNumber')?.hasError('required')) {
                              <span class="error-text">{{ t('validation.serialNumberRequired') }}</span>
                            }
                          </kendo-formfield>
                          <kendo-formfield>
                            <kendo-label [text]="t('name')">*</kendo-label>
                            <kendo-textbox formControlName="name"></kendo-textbox>
                            @if (deviceForm.get('name')?.touched && deviceForm.get('name')?.hasError('required')) {
                              <span class="error-text">{{ t('validation.nameRequired') }}</span>
                            }
                          </kendo-formfield>
                          <kendo-formfield>
                            <kendo-label [text]="t('manufacturer')"></kendo-label>
                            <kendo-textbox formControlName="manufacturer"></kendo-textbox>
                          </kendo-formfield>
                          <kendo-formfield>
                            <kendo-label [text]="t('purchaseDate')"></kendo-label>
                            <kendo-datepicker
                              formControlName="purchaseDate"
                              [placeholder]="t('datePlaceholder')"
                            ></kendo-datepicker>
                          </kendo-formfield>
                          <kendo-formfield>
                            <kendo-label [text]="t('purchaseCost')"></kendo-label>
                            <kendo-numerictextbox
                              formControlName="purchaseCost"
                              [format]="'n2'"
                              [min]="0"
                              [decimals]="2"
                            ></kendo-numerictextbox>
                          </kendo-formfield>
                        </fieldset>
                      </div>
                      <div class="xs12col m4col align-top">
                        <fieldset class="fieldsetContainer">
                          <h2 class="padding-bottom-small">{{ t('maintenance') }}</h2>
                          <kendo-formfield>
                            <span class="tooltipContainer">
                              <kendo-label [text]="t('serviceInterval')">
                                <span [attr.tooltip]="t('tooltipServiceInterval')" flow="right" class="tooltipContainer">
                                  <img class="tooltipIcon" src="../assets/icons/information-icon.svg">
                                </span>
                              </kendo-label>
                            </span>
                            <kendo-numerictextbox
                              formControlName="serviceInterval"
                              [format]="'n0'"
                              [min]="1"
                              [decimals]="0"
                            ></kendo-numerictextbox>
                          </kendo-formfield>
                          <kendo-formfield>
                            <span class="tooltipContainer">
                              <kendo-label [text]="t('nextService')">
                                <span [attr.tooltip]="t('tooltipNextService')" flow="right" class="tooltipContainer">
                                  <img class="tooltipIcon" src="../assets/icons/information-icon.svg">
                                </span>
                              </kendo-label>
                            </span>
                            <kendo-datepicker
                              formControlName="nextService"
                              [placeholder]="t('datePlaceholder')"
                            ></kendo-datepicker>
                            @if (nextServiceComputed) {
                              <span class="hint-text">{{ t('nextServiceComputedHint') }}</span>
                              @if (nextServiceOverrideAvailable) {
                                <a class="link-text" (click)="overrideNextService()">{{ t('nextServiceOverride') }}</a>
                              }
                            } @else if (nextServiceOverridden) {
                              <span class="hint-text">{{ t('nextServiceOverriddenHint') }}</span>
                              @if (canEdit) {
                                <a class="link-text" (click)="resetNextServiceToComputed()">{{ t('nextServiceResetToComputed') }}</a>
                              }
                            }
                          </kendo-formfield>
                          <kendo-formfield>
                            <span class="tooltipContainer">
                              <kendo-label [text]="t('serviceInformation')">
                                <span [attr.tooltip]="t('tooltipServiceInformation')" flow="right" class="tooltipContainer">
                                  <img class="tooltipIcon" src="../assets/icons/information-icon.svg">
                                </span>
                              </kendo-label>
                            </span>
                            <kendo-textarea
                              [rows]="4"
                              formControlName="serviceInformation">
                            </kendo-textarea>
                          </kendo-formfield>
                        </fieldset>
                      </div>
                      <div class="xs12col m4col">
                        <fieldset class="fieldsetContainer flexRow">
                          <div class="buttonContainer">
                            <button
                              kendoButton
                              class="buttonPrimary"
                              type="submit"
                              (click)="saveChanges(vm.device?.id)"
                              [hidden]="!canEdit"
                              [disabled]="deviceForm?.invalid || !deviceForm?.dirty || vm.loading">
                              {{ isNew ? t('submit') : tGlobal('save') }}
                            </button>
                          </div>
                        </fieldset>
                      </div>
                    </div>

                    <button
                      type="button"
                      (click)="deletionDialogOpen(vm.device?.id)"
                      class="buttonSecondary delete padding-top-medium padding-bottom-medium"
                      [hidden]="isNew || !('Permissions.InventoryDevices.Delete' | permission)">
                      {{ tGlobal('delete') }}
                    </button>
                  </form>
                </div>
              </section>
            </ng-template>
          </kendo-tabstrip-tab>
          <kendo-tabstrip-tab title="{{ t('tab.services') }}" [disabled]="isNew">
            <ng-template kendoTabContent>
              <app-inventory-detail-services
                class="xs12col"
                [device]="vm.device"
                [hidden]="isNew"></app-inventory-detail-services>
            </ng-template>
          </kendo-tabstrip-tab>
          <kendo-tabstrip-tab title="{{ t('tab.documents') }}" [disabled]="isNew">
            <ng-template kendoTabContent>
              <app-inventory-detail-attachments
                class="xs12col"
                [deviceId]="vm.device?.id"
                [hidden]="isNew"></app-inventory-detail-attachments>
            </ng-template>
          </kendo-tabstrip-tab>
        </kendo-tabstrip>
        @if (vm.deviceIdToDelete != null && deletionDialogOpened) {
          <kendo-dialog
            title="{{t('confirmDeletion')}}"
            (close)="deletionDialogClose('cancel', vm.deviceIdToDelete)"
            [minWidth]="250"
            [width]="450">
            <p style="margin: 30px; text-align: center;">
              {{t('deletionMessage')}}
            </p>
            <kendo-dialog-actions>
              <button kendoButton (click)="deletionDialogClose('cancel', vm.deviceIdToDelete)">{{ tGlobal('cancel') }}</button>
              <button kendoButton (click)="deletionDialogClose('delete', vm.deviceIdToDelete)" themeColor="primary">{{ tGlobal('delete') }}
              </button>
            </kendo-dialog-actions>
          </kendo-dialog>
        }
      </div>
    }
  </ng-container>
</ng-container>